import styled, { css } from "styled-components";

const priceStyles = css`
    --_font-family: var(--font-semi-bold);
    --_text-color: var(--color-primary-black);

    font-size: 1.6rem;
    line-height: 2rem;
    color: var(--_text-color);
`;

export const Cash = styled.div`
    ${priceStyles};
    display: flex;
    flex-direction: column;
`;

export const CashDiscount = styled.del`
    ${priceStyles};
    text-decoration: line-through;
`;

export const PriceWrapper = styled.div`
    display: flex;
`;
